import { useKontaktyContext } from "../../Providers/KontaktyProvider"

export default function LastUpdateTime() {
    const {state:{lastUpdate}} = useKontaktyContext();
    return(
        <span className="">{lastUpdate}</span>
    )
}